import { all, put, takeEvery } from 'redux-saga/effects';

import * as actionTypes from '../actions/ActionTypes';
import * as api from '../../shared/services/api/apiCard';
import { checkOffline } from '../../shared/services/Utility';

import { Logout, setPurchaseStatus, startLoading, stopLoading, update_price, update_promo_code } from '../actions';

import {
  OFFLINE_USER,
  SESSION_EXPIRED,
  SESSION_EXPIRED_CODE,
  SOMETHING_WRONG,
} from '../../shared/constants/Constants';

function* paymentAuthentication(action) {
  yield put(startLoading());
  try {
    const data = yield api.paymentRequest_API(action.paymentBody);
    if (data.status === 200) {
      yield put(stopLoading());
      yield put(setPurchaseStatus(true));
      action.success(true, data.message);

    } else if (data.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/

      yield put(stopLoading());

      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());

    } else {
      yield put(stopLoading());
      action.success(false, data.message);
      //  Alert.alert(APP_NAME, data.message || "");
    }
    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }

  }
}

function* promoCodeRequest(action) {
  yield put(startLoading());
  try {
    const data = yield api.promocodeRequest_API(action.requestBody);
    if (data.status === 200) {
      yield put(update_promo_code(data.couponCode, data.discountPrice));
    } else if (data.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/

      yield put(Logout());
      // yield put(goto_login())

    } else {
      // Alert.alert(APP_NAME, TextConstant.PAYMENT_ERROR);
    }
    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
  }
}

function* applyPromoCode(action) {

  yield put(startLoading());
  try {
    const data = yield api.applyPromocode_API(action.requestBody);

    if (data.status === 200) {
      yield put(update_price(data.netAmount));
    } else if (data.status === 0) {//status for inavlid token 0
      /*session id expired*/
      yield put(Logout());
      // yield put(goto_login())

    } else {
      //  Alert.alert(APP_NAME, data.message);
    }
    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
  }
}

function* cardPurchaseSaga() {
  yield all([
    takeEvery(actionTypes.MAKE_A_PAYMENT, paymentAuthentication),
    takeEvery(actionTypes.REQUEST_PROMO_CODE, promoCodeRequest),
    takeEvery(actionTypes.APPLY_PROMO_CODE, applyPromoCode),
  ]);
}

export default cardPurchaseSaga;
